import { type FC, useState } from 'react';

import { Typography } from 'enable-ui';

import { ReactComponent as DownIcon } from 'assets/icons/collapse-down.svg';
import { ReactComponent as UpIcon } from 'assets/icons/up.svg';

import type { HeaderTableItem } from './type';

import { COLOR, COLOR_CONFIG } from 'constants/color';

const CustomTable: FC<{
  headers: HeaderTableItem[];
  styleHeader?: React.CSSProperties;
  styleTable?: React.CSSProperties;
  bodies: any[];
  renderBody: (index: number, row: any, column: HeaderTableItem) => React.ReactNode;
  headersChildren?: HeaderTableItem[];
  renderBodyChildren?: (index: number, row: any, column: HeaderTableItem) => React.ReactNode;
  noDataText?: string;
  emptyResultMsg?: string;
}> = ({
  headers,
  styleHeader,
  styleTable,
  bodies,
  renderBody,
  headersChildren,
  renderBodyChildren,
  noDataText,
  emptyResultMsg = 'No data',
}) => {
  const [collapse, setCollapse] = useState<Record<string, boolean>>({});

  const handleCollapse = (id: string) => {
    setCollapse((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div style={{ marginTop: 40, ...styleTable }}>
      <div
        style={{
          background: COLOR_CONFIG['white-smoke'],
          border: `1px solid ${COLOR_CONFIG['white-smoke']}`,
          borderRadius: 12,
          height: 48,
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          ...styleHeader,
        }}
      >
        {headers.map((header, index) => (
          <div key={index} style={{ ...header.style }}>
            <Typography weight={600} variant="body-3" color={COLOR_CONFIG['neutral-text']}>
              {header.title}
            </Typography>
          </div>
        ))}
      </div>
      <div>
        {bodies?.length ? (
          bodies.map((row, index) => {
            return (
              <div
                style={{
                  borderBottom: collapse[row.id]
                    ? 'none'
                    : `1px solid ${COLOR.neutralTrans['neutralTrans-15']}`,
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {headers.map((column, idx) => {
                    const styleCollapse = column.field === 'collapse' ? column.style : {};

                    return (
                      <div
                        style={{
                          padding: '12px 8px',
                          ...column.style,
                        }}
                        key={idx}
                      >
                        {column.field === 'collapse' && (
                          <div
                            style={{
                              ...styleCollapse,
                              width: 50,
                              textAlign: 'center',
                            }}
                          >
                            <div
                              style={{
                                borderRadius: 12,
                                border: '1px solid #00000040',
                                width: 32,
                                height: 32,
                                padding: '0 4px',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                              }}
                              onClick={() => handleCollapse(row.id)}
                            >
                              {collapse[row.id] ? <UpIcon /> : <DownIcon />}
                            </div>
                          </div>
                        )}

                        {renderBody(index, row, column)}
                      </div>
                    );
                  })}
                </div>

                {collapse[row.id] && (
                  <div style={{ background: '#F7F4ED' }}>
                    {row.items?.length > 0 ? (
                      <>
                        <div
                          style={{
                            background: COLOR_CONFIG.doctor,
                            borderBottom: `1px solid ${COLOR.neutralTrans['neutralTrans-15']}`,
                            height: 40,
                            ...styleHeader,
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                          }}
                        >
                          {headersChildren?.map((headerItem, itemIndex) => (
                            <div key={itemIndex} style={{ ...headerItem.style }}>
                              <Typography
                                weight={600}
                                variant="body-3"
                                color={COLOR_CONFIG['neutral-text']}
                              >
                                {headerItem.title}
                              </Typography>
                            </div>
                          ))}
                        </div>
                        <div
                          style={{
                            background: COLOR_CONFIG.doctor,
                          }}
                        >
                          {row.items?.map((bodyChildren: any, bodyIndex: number) => {
                            return (
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  borderBottom: `1px solid ${COLOR.neutralTrans['neutralTrans-15']}`,
                                }}
                                key={bodyIndex}
                              >
                                {headersChildren?.map((columnChildren, idxChildren) => {
                                  return (
                                    <div
                                      style={{
                                        ...columnChildren.style,
                                        padding: '24px 0',
                                      }}
                                      key={idxChildren}
                                    >
                                      {renderBodyChildren?.(
                                        bodyIndex,
                                        bodyChildren,
                                        columnChildren,
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                            );
                          })}
                        </div>
                      </>
                    ) : (
                      <Typography
                        style={{
                          fontSize: '18px',
                          lineHeight: '26px',
                          textAlign: 'center',
                          padding: '12px 0',
                        }}
                      >
                        {row.isHadCFS && row.items.length === 0 && 'No data'}
                        {!row.isHadCFS && noDataText}
                      </Typography>
                    )}
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <Typography
            style={{ textAlign: 'center', padding: 24, fontSize: 18, lineHeight: '26px' }}
          >
            {emptyResultMsg}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default CustomTable;
